import { SessionService } from "./../../Services/session.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { AppSettings } from "../../app-settings";

@Component({
  selector: "app-learning-level",
  templateUrl: "./learning-level.component.html",
  styleUrls: ["./learning-level.component.css"],
})
export class LearningLevelComponent implements OnInit {
  expandIconAssetURL: string = AppSettings.cdnUrl + "assets/images/expand.png";
  collapseIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/collapse_level.png";
  activityPlayBtnIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/activity_play_btn.png";

  expandModuleIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/expand_icon_hollow.png";
  collapseModuleIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/collapse_icon_filled.png";

  @Input() level = {
    grade: "",
    levelName: "",
    collapsed: true,
    activityDetailsCollapsed: true,
    completedActivities: 0,
    totalActivities: 0,
    gradeClass: "",
    totalTimeSpent: 0,
    remainingEffort: 0,
    levelStatus: "",
    startState: "",
    nextActivityName: "",
    overallPerformanceScore: 0,
    activityListInfo: "",
    isRecentModule: "NO",
  };

  @Output() collapse_level = new EventEmitter<any>();

  iconUrls = {
    New: AppSettings.cdnUrl + "assets/images/not_started_small.png",
    "Started Early": AppSettings.cdnUrl + "assets/images/In_progress_LL.svg",
    "Started Normally": AppSettings.cdnUrl + "assets/images/In_progress_LL.svg",
    Completed: AppSettings.cdnUrl + "assets/images/Completed_LL.svg",
    Resumed: AppSettings.cdnUrl + "assets/images/Resumed_LL.svg",
    Abandoned: AppSettings.cdnUrl + "assets/images/Abandoned_LL.svg",
  };
  startStateIcon = {
    "Out Of Sequence": AppSettings.cdnUrl + "assets/images/Abandoned_LL.svg",
    "In Sequence": AppSettings.cdnUrl + "assets/images/Completed_LL.svg",
  };

  grade = {
    A: "Grade A",
    B: "Grade B",
    'A-': "Grade A-",
    'B-': "Grade B-",
    C: "Grade C",
    NR: "NR",
    NA: "NA",
    NG: "NG"
  };

  levelExpandedOrCollapsed = "collapsed";

  constructor(private sessionService: SessionService) {}

  ngOnInit() {
    this.sessionService.getWebinarComponentState.subscribe((state) => {
      if (state === "expanded") {
        this.level.collapsed = true;
      }
    });
  }

  toggleLevelDetailsView() {
    this.level.collapsed = !this.level.collapsed;
  }
  toggleActivityListView() {
    this.level.activityDetailsCollapsed = !this.level.activityDetailsCollapsed;
    if (!this.level.activityDetailsCollapsed) {
      this.sessionService.shareLevelCollapsedStatus("expanded");
    }
  }

  calWidthOfProgressBar(completedActivities, totalActivities) {
    return (completedActivities / totalActivities) * 100;
  }
}
